import React from "react";
import { getBGforMenuAvatar, getInitials, getTimeForMessage, isGroupActive } from "./helper";
import { useDispatch, useSelector } from "react-redux";
import { socket } from "../../../service/socket";
import { GET_MESSAGE_LIST } from "../../../redux/constants";

const SideMenuTile = ({group, name, message, activeGroup, setActiveGroup, setPage, hasMoreRef }) => {
  const dispatch = useDispatch();
  const {email, company} = useSelector(state => state.auth);

  const handleGroupSelection = () => {

    const payload = {
      sender_email: email,
      receiver_email: group.email,
      company_id: company.id,
    };
    socket.emit("mark_read_message", payload);
    setPage(1);
    hasMoreRef.current = true;
    dispatch({ type: GET_MESSAGE_LIST, payload: {message: [], totalPages: 0, currentPage: 1} });

    if(setActiveGroup)
      setActiveGroup(group);
  }

  const getMessage = (message) => {
    try {
      JSON.parse(message);
      return "Send you a file.";
    } catch (error) {
        return message;
    }
  }

  return (
    <div onClick={handleGroupSelection} className={`w-full h-[73px] rounded-md my-2 flex items-center space-x-2 cursor-pointer px-4 py-3 ${isGroupActive(group, activeGroup) ? 'bg-[#2F80ED]' : 'bg-[--bg-color-50]'}`}>
      <div>
        <div className={`w-[44px] h-[44px] flex justify-center items-center rounded-full ${isGroupActive(group, activeGroup) ? "bg-white text-[#2F80ED]" : `text-white ${getBGforMenuAvatar(name)}`}`}>
            { ["customer", "collaborator", "internal chat"].some((item) => name.toLowerCase().includes(item)) ? (<span className="fa-solid fa-user-group"></span>) : (
                <div className="font-inter font-medium text-base">{getInitials(name)}</div>
            )}
        </div>
      </div>
      <div className="w-full h-full flex flex-col">
        <div className="w-full flex items-center justify-between">
            <div className={`font-inter font-semibold text-sm capitalize ${isGroupActive(group, activeGroup) ? "text-white" : "text-[#1E293B]"} line-clamp-1`}>{name}</div>
            <div className={`font-inter font-semibold text-[10px] ${isGroupActive(group, activeGroup) ? "text-white" : "text-[#2F80ED]"} whitespace-nowrap`}>{getTimeForMessage(group?.createdAt)}</div>
        </div>
        <div className="w-full flex items-center justify-between">
            <div className={`w-[90%] font-inter text-[12px] ${isGroupActive(group, activeGroup) ? "text-white" : "text-[#78818F]"} leading-3 line-clamp-2`}>{getMessage(message)}</div>
              {group?.is_read?.includes(email) && (
                <div>
                  <div className="w-[14px] h-[14px] rounded-full bg-[#2F80ED]"></div>
                </div>
              )}
        </div>
      </div>
    </div>
  );
};

export default SideMenuTile;
